import { createStyles, makeStyles, } from '@material-ui/core';
export const useRefreshButtonStyles = makeStyles((theme) => createStyles({
    refreshbutton: {},
}));
//# sourceMappingURL=useRefreshButtonStyles.js.map